import PromoCardGastroGidDesktop from '@images/promo-card/promo-card-gastrogid--desktop.png'
import PromoCardGastroGidMobile from '@images/promo-card/promo-card-gastrogid--mobile.png'
import PromoCardTgBotDesktop from '@images/promo-card/promo-card-tg-bot--desktop.png'
import PromoCardTgBotMobile from '@images/promo-card/promo-card-tg-bot--mobile.png'
import PromoCardOwnerDesktop from '@images/promo-card/promo-card-owner--desktop.png'
import PromoCardOwnerMobile from '@images/promo-card/promo-card-owner--mobile.png'
import PromoCardKuperDesktop from '@images/promo-card/promo-card-kuper--desktop.png'
import PromoCardKuperMobile from '@images/promo-card/promo-card-kuper--mobile.png'
import { TypePromoItemDefault, TypePromoItemKuper } from '@features/PromoRoll/types/types'

export const allPromoData: Record<string, TypePromoItemDefault | TypePromoItemKuper> = {
  kuper: {
    id: 'kuper',
    description: 'Закажите доставку Купер',
    src: {
      desktop: PromoCardKuperDesktop.src,
      mobile: PromoCardKuperMobile.src,
    },
    href: 'https://kuper.ru/',
  },
  gastrogid: {
    id: 'gastrogid',
    description: 'Гастрогид Афиши в telegram',
    src: {
      desktop: PromoCardGastroGidDesktop.src,
      mobile: PromoCardGastroGidMobile.src,
    },
    href: 'https://t.me/afisharestaurants',
  },
  'bot-accomplice': {
    id: 'bot-accomplice',
    description: 'Бот-сообщник от Афиши',
    src: {
      desktop: PromoCardTgBotDesktop.src,
      mobile: PromoCardTgBotMobile.src,
    },
    href: 'https://t.me/AfishaRu_Robot',
  },
  'possibilities-restaurateurs': {
    id: 'possibilities-restaurateurs',
    description: 'Возможности для рестораторов',
    src: {
      desktop: PromoCardOwnerDesktop.src,
      mobile: PromoCardOwnerMobile.src,
    },
    href: 'https://www.afisha.ru/msk/restaurants/restorator/',
  },
}
